<template>
    <div :class="dialog_opened?'custom-right-drawer':''">
      <v-navigation-drawer
        v-model="drawerState"
        location="end"
        temporary
        :width="drawerWidth"
        :color="sidebarColor"
        @click:outside="closeDrawer"
        :scrim="true"
      >
        <v-toolbar flat :color="sidebarColor">
          <v-toolbar-title class="pl-1">{{ drawerTitle }}</v-toolbar-title>
          <v-btn icon @click="closeDrawer">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container style="margin-top: -16px;">
          <component :is="component" :moduleName="moduleName"/>
        </v-container>
      </v-navigation-drawer>
    </div>
</template>

<script>
import { useRightDrawerStore } from "@/store/rightDrawer";
import { useDialogsStore } from "@/store/dialogs"; // 👈 Importa el dialog store
import { computed, defineAsyncComponent } from "vue";
import { useTheme } from 'vuetify';

export default {
  name: "RightDrawer",
  setup() {
    const rightDrawerStore = useRightDrawerStore();
    const dialogsStore = useDialogsStore(); // 👈

    const drawerTitle = computed(() => rightDrawerStore.drawerTitle);
    const drawerWidth = computed(() => rightDrawerStore.drawerWidth);
    const drawerState = computed({
      get: () => rightDrawerStore.isOpen,
      set: (value) => {
        if (!value) rightDrawerStore.closeDrawer();
      },
    });

    // Dynamically import the component based on the store value
    const component = computed(() => {
      const componentName = rightDrawerStore.component;
      if (!componentName) {
        return defineAsyncComponent(() => import('../drawer/DefaultComponent.vue'));
      }
      return defineAsyncComponent(() => import(`../drawer/${componentName}.vue`));
    });

    const moduleName = computed(() => rightDrawerStore.module);

    const dialog_opened = computed(() => {
      return dialogsStore.openDialog1!=null
    });
    
    const theme = useTheme();
    const sidebarColor = computed(() => {return theme.global.current.value.dark ? 'sidebar' : 'white'});

    return {
      sidebarColor,
      drawerState,
      closeDrawer: rightDrawerStore.closeDrawer,
      drawerTitle,
      drawerWidth,
      component,
      moduleName,
      rightDrawerStore,
      dialog_opened
    };
  },
};
</script>
